import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, TableRow, TableCell, Table, Grid, Icon, Tooltip } from '@material-ui/core';
import { TableHead, TableBody, Radio, Checkbox } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import QuestionGradeIcon from '../components/QuestionGradeIcon';
import NoteInfo from '../../../components/note/NoteInfo';
import * as CanvasFunctions from '../components/CanvasFunctions';
import '../../../../styles/canvas.css';

const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '20%',
    },
    expansion: {
        background: '#FAFAFA',
    }
});

class QuestionScore extends Component {
    svgRef = React.createRef();
    state = {
        expanded: false,
        obj_list: [],
        svgCoord: {},
    }

    componentDidMount = () => {
        const { question } = this.props;
        let svgCoord = {};

        if (this.svgRef.current !== null) {
            svgCoord = this.svgRef.current.getBoundingClientRect();
        }

        this.setState({
            obj_list: CanvasFunctions.parseRelativeCoordinatesForObjList(question.image.shape_list, svgCoord),
            svgCoord: svgCoord
        });
    }

    handleExpandClick = () => {
        this.setState({
            ...this.state,
            expanded: !this.state.expanded
        });
    }

    getIconContent = (score, max_score, is_graded, answer_count, is_correct_available) => {
        if (!is_graded) {
            return (
                <Tooltip title="Awaiting Instructor Grade">
                    <Icon style={{ color: 'orange' }}>history</Icon>
                </Tooltip>
            );
        }

        if (score === max_score && answer_count > 0 && is_correct_available) {
            return (
                <Tooltip title="Correct">
                    <Icon style={{ color: 'green' }}>check</Icon>
                </Tooltip>
            );
        }

        if (score > 0 && score < max_score) {
            return (
                <Tooltip title="Partially Correct">
                    <Icon style={{ color: 'orange' }}>check</Icon>
                </Tooltip>
            );
        }

        return (
            <Tooltip title="Incorrect">
                <Icon style={{ color: 'red' }}>close</Icon>
            </Tooltip>
        );
    }

    isAnswerSelected = (answer_id, studentAnswerList) => {
        let is_selected = false;

        if (typeof studentAnswerList !== 'undefined') {
            studentAnswerList.forEach((student_answer) => {
                if (student_answer.answer_id === answer_id) {
                    is_selected = true;
                }
            });
        }

        return is_selected;
    }

    getStudentAnswerOrder = (answer_id, studentAnswerList) => {
        let student_order = 0;

        if (typeof studentAnswerList !== 'undefined') {
            studentAnswerList.forEach((student_answer) => {
                if (student_answer.answer_id === answer_id) {
                    student_order = student_answer.AnswerOrder;
                }
            });
        }

        return student_order;
    }

    getAnswerContent = (question, studentQuestion) => {
        switch (question.header.question_type_id) {
            case (4): // Multiple Answer
            case (1): // Multiple Choice
                {
                    return (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: '10%' }}></TableCell>
                                    <TableCell style={{ width: '10%' }}></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {question.answerList.map((answer) =>
                                    <TableRow key={answer.header.answer_id}>
                                        <TableCell>
                                            {(answer.header.Correct ? <Icon style={{ color: 'green' }}>check</Icon> : <Icon style={{ color: 'red' }}>close</Icon>)}
                                        </TableCell>
                                        <TableCell>
                                            {question.header.question_type_id === 1 ?
                                                <Radio
                                                    checked={this.isAnswerSelected(answer.header.answer_id, studentQuestion.studentAnswerList)}
                                                    disabled
                                                />
                                                :
                                                <Checkbox
                                                    checked={this.isAnswerSelected(answer.header.answer_id, studentQuestion.studentAnswerList)}
                                                    disabled
                                                />
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {answer.header.AnswerText}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    );
                }

            case (2): // Short Answer
            case (3): // Long Answer
                {
                    let studentAnswerText = typeof studentQuestion.studentAnswerList[0] !== 'undefined' ? studentQuestion.studentAnswerList[0].AnswerText || '' : '';
                    let instructorAnswerText = typeof question.answerList[0].header !== 'undefined' ? question.answerList[0].header.AnswerText || '' : '';

                    return (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: '10%' }}></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Student Answer:</TableCell>
                                    <TableCell>{studentAnswerText}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Instructor Answer:</TableCell>
                                    <TableCell>{instructorAnswerText}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    );
                }

            case (5): // Order Answer
                {
                    return (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: '10%' }}>Order</TableCell>
                                    <TableCell style={{ width: '10%' }}>Answer</TableCell>
                                    <TableCell>Text</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {question.correctList.map((answer) =>
                                    <TableRow key={answer.header.answer_id}>
                                        <TableCell>
                                            {answer.header.CorrectOrder}
                                        </TableCell>
                                        <TableCell>
                                            {this.getStudentAnswerOrder(answer.header.answer_id, studentQuestion.studentAnswerList)}
                                        </TableCell>
                                        <TableCell>
                                            {answer.header.AnswerText}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    );
                }

            case (6): // Hotspot Answer
                console.log(question)
                {
                    let student_answer_position = {};
                    if (studentQuestion.studentAnswerList.length > 0) {
                        student_answer_position = CanvasFunctions.parseRelativeCoordinatesForObj({
                            id: studentQuestion.studentAnswerList[0].student_answer_id,
                            xPosition: studentQuestion.studentAnswerList[0].xPosition,
                            yPosition: studentQuestion.studentAnswerList[0].yPosition,
                            type: 'cross',
                        }, this.state.svgCoord);
                    }

                    return (
                        <div className="canvas_wrapper">
                            <div className="canvas" style={{ width: "640px", height: "360px" }}>
                                <svg ref={this.svgRef} >
                                    <image href={question.image.URL} style={{ height: '100%', width: '100%' }} />
                                    {CanvasFunctions.renderCanvas(this.state.obj_list.concat(student_answer_position))}
                                </svg>
                            </div>
                        </div>
                    )
                }

            default: {
                return (<React.Fragment>Loading...</React.Fragment>);
            }
        }
    }

    render() {
        const { classes, question, studentQuestion } = this.props;
        const { expansionPanelOpen } = this.state;
        const answer_content = this.getAnswerContent(question, studentQuestion);

        return (
            <React.Fragment>
                <ExpansionPanel expanded={expansionPanelOpen} onChange={this.handleChange}>
                    <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.expansion}>
                        <div className={classes.column}>
                            <Typography className={classes.heading}>Question #{question.header.DisplayOrder}</Typography>
                        </div>
                        <div className={classes.column}>
                            <Typography className={classes.heading}>{studentQuestion.Score}/{question.header.Score}</Typography>
                        </div>
                        <div className={classes.column}>
                            <Typography className={classes.heading}>
                                <QuestionGradeIcon
                                    question={question}
                                    studentQuestion={studentQuestion}
                                />
                            </Typography>
                        </div>
                        {
                            this.props.noteList.filter(n => n.relationList.filter(r => r.NoteReferenceID === studentQuestion.student_question_id).length > 0).length > 0 ?
                                <div className={classes.column} style={{ float: 'right' }}>
                                    <Tooltip title="Instructor attached a Note">
                                        <Icon>announcement</Icon>
                                    </Tooltip>
                                </div>
                            :
                                null
                        }

                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className={classes.details}>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                <Typography>{question.header.QuestionText}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                {answer_content}
                            </Grid>
                            <Grid item xs={6}>
                                <NoteInfo
                                    type="student"
                                    table_name='student_question'
                                    table_id={studentQuestion.student_question_id}
                                />
                            </Grid>
                        </Grid>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </React.Fragment>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ auth, quizApp, note }) {
    return {
        auth,
        quiz: quizApp.quizzes.currentQuiz,
        noteList: note.note.noteList
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(QuestionScore)));


// WEBPACK FOOTER //
// src/main/content/quiz/quizScore/QuestionScore.js